import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './modules/general/home/home.component';
import { NotFoundComponent } from './modules/general/not-found/not-found.component';
import { IgniteComponent } from './modules/general/readignite/readignite.component';
import { PartFinderComponent } from './modules/general/part-finder/part-finder.component';
// import { CuttingtoolComponent } from './modules/general/products/cuttingtool/cuttingtool.component';
import { OurBusinessComponent } from './modules/general/our-business/our-business.component';
import { CareerComponent } from './modules/general/career/career.component';
import { SearchResultComponent } from './modules/general/search-result/search-result.component';
const routes: Routes = [
  { path: '', 
      loadChildren: () => import('./modules/general/home/home.module')
      .then(mod => mod.HomeModule)
    },
  // { path: '/*', redirectTo: '', pathMatch: 'full' },
  {
    path: 'httpclient',
    loadChildren: () => import('./modules/application/items/items.module')
      .then(mod => mod.ItemsModule)
  },  
  { path: 'read-ignite',component: IgniteComponent, },  
  {
    path: 'carreras',
    loadChildren: () => import('./modules/general/career/career.module')
      .then(mod => mod.CareerModule)
  }, 
  {
    path: 'buscador-web/:langValue/:searchValue',
    loadChildren: () => import('./modules/general/search-result/search-result.module')
      .then(mod => mod.SearchReaultlModule)
  }, 
  {
    path: 'nuestros-negocios',
    loadChildren: () => import('./modules/general/our-business/our-business.module')
      .then(mod => mod.OurBusinessModule)
  },
  {
    path: 'part-finder',
    loadChildren: () => import('./modules/general/part-finder/part-finder.module')
      .then(mod => mod.PartFinderModule)
  },
  {
    path: 'acerca-de-nosotros',
    loadChildren: () => import('./modules/general/about/about.module')
      .then(mod => mod.AboutModule)
  },
  {
    path: 'producto',
    loadChildren: () => import('./modules/general/products/products.module')
      .then(mod => mod.ProductsModule)
  },
  {
    path: 'soporte-tecnico',
    loadChildren: () => import('./modules/general/technical/technical.module')
      .then(mod => mod.TechnicalModule)
  },
  {
    path: 'services',
    loadChildren: () => import('./modules/application/example-services/tutorial.module')
      .then(mod => mod.TutorialModule)
  },
  {
    path: 'soporte-comercial',
    loadChildren: () => import('./modules/general/commerical/commerical.module')
      .then(mod => mod.CommericalModule)
  },    
  {
    path: 'bootstrap',
    loadChildren: () => import('./modules/application/example-bootstrap/tutorial.module')
      .then(mod => mod.TutorialModule)
  },  
  {
    path: 'contacto',
    loadChildren: () => import('./modules/general/contact/contact.module')
      .then(mod => mod.ContactModule)
  },

  {
    path: 'signin',
    loadChildren: () => import('./modules/general/signin/signin.module')
      .then(mod => mod.SigninModule)
  },
  { 
    path: '**',redirectTo:'',  
    loadChildren: () => import('./modules/general/home/home.module')
      .then(mod => mod.HomeModule)  
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })
    ,
  [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })]
  ],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }